import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';

import {SortDirection, SortDirectionPropType} from "utils/DBUtils";

/**
 * Get font awesome icon for a SortDirection
 * @param direction
 * @returns string - SortDirection
 */
const iconForSort = (direction) => {
    switch (direction) {
        case SortDirection.Ascending:
            return "sort ascending";
        case SortDirection.Descending:
            return "sort descending";
        default:
            return "sort";
    }
};

const SortIcon = (props) => {
    return (
        <Icon onClick={props.onClick} name={iconForSort(props.currentDirection)} />
    );
};

SortIcon.propTypes = {
    currentDirection: SortDirectionPropType,
    onClick: PropTypes.func
};

export default SortIcon;


// WEBPACK FOOTER //
// ./public/components/common/SortIcon.jsx